/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "thumbs-down-15474b70--sprite",
  "use": "thumbs-down-15474b70--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"thumbs-down-15474b70--sprite\"><g transform=\"translate(36 36) rotate(180)\"><g transform=\"translate(36 36) rotate(180)\" opacity=\"0\"><g fill=\"#fff\" stroke=\"#707070\" stroke-width=\"1\" opacity=\"0.5\"><rect width=\"36\" height=\"36\" stroke=\"none\" /><rect x=\"0.5\" y=\"0.5\" width=\"35\" height=\"35\" fill=\"none\" /></g></g></g><g transform=\"translate(27.937 26.441) rotate(180)\"><g transform=\"translate(0 6.641)\"><path d=\"M4.033,8.533A3.273,3.273,0,0,0,5.162,10.8l-2.275-.008A2.519,2.519,0,0,1,.38,8.451L.006,2.673A2.5,2.5,0,0,1,2.5,0L5.021.008A3.314,3.314,0,0,0,3.635,2.964Z\" fill=\"currentColor\" /></g><g transform=\"translate(4.408)\"><path d=\"M14.5,8.683l-1.212,7.305a1.732,1.732,0,0,1-1.719,1.453L2.9,17.433a2.5,2.5,0,0,1-2.5-2.324l-.4-5.57a2.5,2.5,0,0,1,1.3-2.382,2.878,2.878,0,0,1,.4-.174,1.655,1.655,0,0,0,1.046-1l1.818-4.84a1.739,1.739,0,0,1,3.37.6,1.706,1.706,0,0,1-.117.623L6.682,5.413a.912.912,0,0,0,.862,1.228l5.242.009a1.751,1.751,0,0,1,1.336.622A1.732,1.732,0,0,1,14.5,8.683Z\" fill=\"currentColor\" /></g></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
